// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3BiX1","title":"Images45_title__1koGX","images":"Images45_images__2DL2g"};